import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../common/Button';
import { useInView } from '../../hooks/useInView';
import './CTABand.css';

const CTABand: React.FC = () => {
  const navigate = useNavigate();
  const { ref: ctaRef, isInView: ctaInView } = useInView<HTMLElement>({ threshold: 0.35 });
  const titleWords = ['Make', 'Your', 'Ceremony', 'Unforgettable'];

  const handleRequestQuote = () => {
    navigate('/contact');
  };

  return (
    <section
      ref={ctaRef}
      className={`cta-band ${ctaInView ? 'cta-band-visible' : ''}`}
      style={{ backgroundImage: `url('/Untitled design (22).png')` }}
    >
      <div className="cta-band-overlay" />
      <div className="cta-band-container">
        <h2 className="cta-band-title" aria-label="Make Your Ceremony Unforgettable">
          {titleWords.map((word, index) => (
            <span
              key={word}
              className="cta-band-word"
              style={{ ['--word-index' as any]: index }}
            >
              {word}
            </span>
          ))}
        </h2>
        <Button 
          variant="outline" 
          onClick={handleRequestQuote}
          className="cta-band-button"
        >
          Request a Quote
        </Button>
      </div>
    </section>
  );
};

export default CTABand;
